<template>
  <v-layout row wrap class="ch-info-component">
    <v-flex xs12 class="pt-0">
      <v-card>
        <v-card-title class="head">
          <v-layout row wrap>
            <v-flex xs12>
              <i class="fas fa-user-circle fa-fw"></i>
              <span class="info-name ml-2">{{ (name !== null) ? name : 'None' }}</span>
              <span class="info-id ml-2"><b>[</b> {{ (domain_name !== null) ? domain_name : 'None' }} <b>]</b></span>
              <button class="ml-2" @click="copyText" v-if="domain_name">
                  <i class="far fa-clone"></i>
                </button>
              <span class="box">
                <span class="name">UPDATED</span>
                <span class="time">{{ updated_at }}</span>
              </span>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="body ch-info-field-border">
          <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
            <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-h-square fa-fw"></i>
                    <span class="ml-2">HOTEL</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="name"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-map-marker-alt fa-fw"></i>
                  <span class="ml-2">ADDRESS</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="address"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-hourglass-start fa-fw"></i>
                  <span class="ml-2">CHECKIN</span>
                </div>
                <div class="ch-info-field-body">
                  <v-layout row>
                    <v-flex xs6>
                      <v-select
                        class="pt-0"
                        :items="hourItems"
                        v-model="checkin_hour"
                        content-class="detail-select"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        class="pt-0"
                        :items="minuteItems"
                        v-model="checkin_minute"
                        content-class="detail-select"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-clock fa-fw"></i>
                  <span class="ml-2">TIMEZONE</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="timezoneItems"
                    v-model="timezone"
                    autocomplete
                    content-class="detail-autocomplete-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-hourglass-end fa-fw"></i>
                  <span class="ml-2">CHECKOUT</span>
                </div>
                <div class="ch-info-field-body">
                  <v-layout row>
                    <v-flex xs6>
                      <v-select
                        class="pt-0"
                        :items="hourItems"
                        v-model="checkout_hour"
                        content-class="detail-select"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        class="pt-0"
                        :items="minuteItems"
                        v-model="checkout_minute"
                        content-class="detail-select"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0" v-if="visibleTag">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-tag fa-fw"></i>
                  <span class="ml-2">TAG</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="tag"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-calendar-check fa-fw"></i>
                  <span class="ml-2">CREATED AT</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="created_at"
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0" v-if="visibleTag">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-tag fa-fw"></i>
                  <span class="ml-2">TYPE</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="typeItems"
                    v-model="type"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-file-alt fa-fw"></i>
                  <span class="ml-2">DESCRIPTION</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="desc"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-volume-up'></i>
                  <span class="ml-2">LATCH WARNING</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="latchItems"
                    v-model="latch_warning"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-code-branch'></i>
                  <span class="ml-2">PINCODE VERSION</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeVersionItems"
                    v-model="pincode_version"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-window-minimize'></i>
                  <span class="ml-2">PINCODE LENGTH</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeLengthItems"
                    v-model="pincode_length"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class="fas fa-fire"></i>
                  <span class="ml-2" style="font-size: 11px">PINCODE DAY TYPE OFFSET</span>
                </div>
                <div class="ch-info-field-body">
                  <v-text-field
                    class="pt-0"
                    v-model="pincode_day_type_offset"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pa-0">
              <div class="ch-info-field">
                <div class="ch-info-field-title">
                  <i class='fas fa-flag'></i>
                  <span class="ml-2">PINCODE ISSUABLE</span>
                </div>
                <div class="ch-info-field-body">
                  <v-select
                    class="pt-0"
                    :items="pincodeIssuableItems"
                    v-model="is_pincode_issuable"
                    content-class="detail-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <div class="btn-wrapper">
            <router-link :to="{name: 'hotels'}">
              <button class="ch-menu-btn ch-menu-backbtn" type="button">
                <i class="fas fa-angle-left fa-fw"></i>
                LIST
              </button>
            </router-link>
            <v-spacer></v-spacer>
            <button
              class="save"
              @click="this.updateHotel"
            >
              <i class="fas fa-save fa-fw"></i>
              <span>SAVE</span>
            </button>
            <button
              class="delete"
              @click="openDeleteDialog"
              :hidden="isNotRootAdmin()"
            >
              <i class="fas fa-times-circle fa-fw"></i>
              <span>DELETE</span>
            </button>
            <!-- NOTE: Delete Dialog -->
            <v-dialog v-model="deleteDialog" class="ch-dialog" max-width="400">
              <div class="ch-dialog-card">
                <v-toolbar class="ch-dialog-toolbar" :height="45">
                  <v-toolbar-title>
                    <i class="fas fa-h-square fa-fw"></i>
                    <span class="title">DELETE HOTEL</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <button @click="closeDialog" class="close-btn">
                    <i class="fas fa-window-close fa-fw"></i>
                  </button>
                </v-toolbar>
                <div class="ch-dialog-body">
                  <v-form v-model="valid" ref="form">
                    <v-layout row wrap>
                      <v-flex xs12 class="pl-3 pr-3">
                        <div class="form-group">
                          <div class="form-title">LOGIN PASSWORD</div>
                          <div class="form-input">
                            <v-text-field
                              class="ch-input-pwd pt-0"
                              v-model="input_password"
                              :rules="passwordRules"
                              full-width
                            ></v-text-field>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="form-title">HOTEL NAME</div>
                          <div class="form-input">
                            <v-text-field
                              v-model="input_hotel_name"
                              :rules="nameRules"
                              full-width
                            ></v-text-field>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </div>
                <v-card>
                  <v-card-title primary-title>
                    <div>
                      <div class="text"><h3>Once you delete a hotel, the following information will also be deleted and there is no going back. Please be certain.</h3></div>
                      <span class="text">
                        <br>- All hotel property like buildings, floors, corridors, rooms.
                        <br>- All door lock install information
                        <br>- All mobilekeys
                        <br>- All bookings
                        <br>- All staff account
                        <br>- All history
                      </span>
                    </div>
                  </v-card-title>
                </v-card>
                <div class="ch-dialog-footer">
                  <button
                    class="cancel"
                    @click="closeDialog"
                  >
                    <i class="fas fa-times-circle fa-fw"></i>
                    <span>CANCEL</span>
                  </button>
                  <button
                    :class="{ delete: valid }"
                    :disabled="!valid"
                    @click="deleteHotel"
                  >
                    <i class="fas fa-save fa-fw"></i>
                    <span>DELETE</span>
                  </button>
                </div>
              </div>
            </v-dialog>
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import momentTimezone from 'moment-timezone';
  // import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        valid: true,
        input_password: null,
        input_hotel_name: null,
        id: null,
        name: null,
        domain_name: null,
        address: null,
        timezone: null,
        timezoneItems: [],
        tag: '',
        type: '',
        visibleTag: false,
        visibleType: false,
        typeItems: ['public', 'private'],
        latchItems: ['Enable', 'Disable'],
        pincodeVersionItems: ['V1', 'V2'],
        pincodeLengthItems: [4, 6, 8],
        pincodeIssuableItems: ['Enable', 'Disable'],
        // NOTE: Readonly
        created_at: null,
        updated_at: null,
        hourItems: [],
        minuteItems: [],
        checkin_hour: null,
        checkin_minute: null,
        checkout_hour: null,
        checkout_minute: null,
        latch_warning: null,
        desc: null,
        pincode_version: null,
        pincode_length: null,
        pincode_day_type_offset: null,
        is_pincode_issuable: null,
        // NOTE: File upload
        booking_logo: null,         // File src
        booking_logo_name: null,    // File name
        staff_logo: null,           // File src
        staff_logo_name: null,      // File name
        deleteDialog: false,
        passwordRules: [
          v => (v === 0) || !!v || 'Please input Password',
        ],
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
      };
    },
    methods: {
      /**
       * @description all timezone list
       * @returns { Array }
       */
      getTimezoneList() {
        return momentTimezone.tz.names();
      },
      /**
       * @description 시간 배열 생성
       * @returns { Array } hours
       */
      setHour() {
        const hours = [];
        for (let index = 0; index < 24; index += 1) {
          hours.push({
            text: index.toString(),
            value: index.toString(),
          });
        }
        return hours;
      },
      /**
       * @description minute 배열 생성
       * @returns { Array } minutes
       */
      setMimute() {
        const minutes = [];
        for (let index = 0; index < 60; index += 1) {
          minutes.push({
            text: index.toString(),
            value: index.toString(),
          });
        }
        return minutes;
      },
      getHotelDetail() {
        api.getHotelDetail(this.id)
        .then((result) => {
          const resultData = result.data;
          if (result.status === 200) {
            if (result.data.latch_warning === 1) resultData.latch_warning = 'Enable';
            else resultData.latch_warning = 'Disable';
            if (result.data.is_pincode_issuable === true) resultData.is_pincode_issuable = 'Enable';
            else resultData.is_pincode_issuable = 'Disable';
            Object.assign(this, resultData);
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'hotels' });
          }
        });
      },
      updateHotel() {
        const id = this.id;
        const params = {
          name: this.name,
          address: this.address,
          timezone: this.timezone,
          checkin_hour: this.checkin_hour,
          checkout_hour: this.checkout_hour,
          checkin_minute: this.checkin_minute,
          checkout_minute: this.checkout_minute,
          latch_warning: this.latch_warning === 'Enable' ? 1 : 0,
          tag: this.tag,
          type: this.type,
          pincode_version: this.pincode_version,
          pincode_length: this.pincode_length,
          pincode_day_type_offset: this.pincode_day_type_offset,
          // eslint-disable-next-line
          is_pincode_issuable: this.is_pincode_issuable === 'Enable' ? true : false,
          // TODO: description 추가 필요
          desc: this.desc,
        };
        api.updateHotel(id, params)
          .then((result) => {
            const resultData = result.data;
            if (result.status === 200) {
              if (result.data.latch_warning === 1) resultData.latch_warning = 'Enable';
              else resultData.latch_warning = 'Disable';
              if (result.data.is_pincode_issuable === true) resultData.is_pincode_issuable = 'Enable';
              else resultData.is_pincode_issuable = 'Disable';
              Object.assign(this, resultData);
              this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
              this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
              this.latch_warning = resultData.latch_warning;
              this.is_pincode_issuable = resultData.is_pincode_issuable;
              this.alert.type = 'check_circle';
              this.alert.color = 'green';
              this.alert.message = 'Success Save';
              this.alertOccur();
            }
          })
          .catch((err) => {
            this.alert.type = 'error';
            this.alert.color = 'red';
            this.alert.message = err.response.data.message;
            this.alertOccur();
          });
      },
      deleteHotel() {
        const id = this.id;
        const querystring = {
          password: this.input_password,
          name: this.input_hotel_name,
        };
        api.deleteHotel(id, querystring)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success delete';
            this.alertOccur();
            this.closeDialog();
            this.deleteDialog = false;
            this.$router.push({ name: 'hotels' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          if (err.response.data.code === 401) {
            this.alert.message = 'Invalid login password';
          } else if (err.response.data.code === 400) {
            this.alert.message = 'Invalid Hotel name';
          } else {
            this.alert.message = err.response.data.message;
          }
          this.alertOccur();
        });
      },
      // NOTE: File upload
      // openFileUpload(target) {
      //   this.$refs[target].click();
      // },
      // onFileChange(target, targetName, e) {
      //   const files = e.target.files || e.dataTransfer.files;
      //   if (!files.length) {
      //     return;
      //   }
      //   this.createImage(files[0], target, targetName);
      // },
      // createImage(file, target, targetName) {
      //   const reader = new FileReader();
      //   const vm = this;

      //   reader.onload = (e) => {
      //     vm[target] = e.target.result;
      //     vm[targetName] = file.name;
      //   };
      //   reader.readAsDataURL(file);
      // },
      // removeImage(target, targetName) {
      //   this[target] = '';
      //   this[targetName] = '';
      // },
      // NOTE: Open dialog
      isNotRootAdmin() {
        if (localStorage.getItem('domain_type') !== 'root') {
          return true;
        }
        return false;
      },
      openDeleteDialog() {
        window.console.log('openDeleteDialog');
        this.deleteDialog = true;
      },
      closeDialog() {
        this.deleteDialog = false;
        this.$refs.form.reset();
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.domain_name;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
    },
    mounted() {
      this.timezoneItems = this.getTimezoneList();      // set timezone list
      this.id = this.$route.params.id;
      this.getHotelDetail();
      this.hourItems = this.setHour();
      this.minuteItems = this.setMimute();
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.visibleTag = true;
        this.visibleType = true;
      }
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/hotels/HotelsDetailInfo.vue